export default {
  GET_ROLEGROUPS: 'GET_ROLEGROUPS',
  SAVE_ROLEGROUP: 'SAVE_ROLEGROUP',
  DELETE_ROLEGROUP: 'DELETE_ROLEGROUP',
  GET_ROLES: 'GET_ROLES',
  SAVE_ROLE: 'SAVE_ROLE',
  DELETE_ROLE: 'DELETE_ROLE',
  ASSIGN_ROLES: 'ASSIGN_ROLES',
  GET_PERMISSIONGROUPS: 'GET_PERMISSIONGROUPS',
  SAVE_PERMISSIONGROUP: 'SAVE_PERMISSIONGROUP',
  DELETE_PERMISSIONGROUP: 'DELETE_PERMISSIONGROUP',
  GET_PERMISSIONS: 'GET_PERMISSIONS',
  SAVE_PERMISSION: 'SAVE_PERMISSION',
  DELETE_PERMISSION: 'DELETE_PERMISSION',
  GET_USERS: 'GET_USERS',
  SAVE_USER: 'SAVE_USER',
  DELETE_USER: 'DELETE_USER'
}
